module.exports = __webpack_public_path__ + "fonts/fa-brands-400.30cc681d.eot";